export default "__VITE_ASSET__L$uPWha0__"